import React from 'react'
import { Button, ButtonGroup } from '@mui/material'
import { ChevronLeftMD, ChevronRightMD } from 'redesign/components/atoms/Icon'
import { ChildContainer } from './styles'
import type { ArrowButtonGroupProps } from './types'

const ArrowButtonGroup: React.FC<ArrowButtonGroupProps> = ({
  handlePreviousButton,
  handleNextButton,
  hideArrows = false,
  children,
}) => (
  <ButtonGroup>
    {!hideArrows && (
      <Button data-testid="calendar__button-prev" variant="text" onClick={handlePreviousButton}>
        <ChevronLeftMD />
      </Button>
    )}
    <ChildContainer>{children}</ChildContainer>
    {!hideArrows && (
      <Button data-testid="calendar__button-next" variant="text" onClick={handleNextButton}>
        <ChevronRightMD />
      </Button>
    )}
  </ButtonGroup>
)

export default ArrowButtonGroup
